module.exports = __webpack_public_path__ + "static/carusel-wp-7f106ba67dd850874f9c6b25bcfa03b5.webp";